import $ from "jquery";
const themeResponsive = {
  current_width: window.innerWidth,
  min_width: 768,
  mobile: false,
  callbacks: []
};
const emit = (eventName, data) => {
  themeResponsive.callbacks.forEach((callback) => {
    if (callback.event === eventName) {
      callback.fn(data);
    }
  });
};
const on = (eventName, callback) => {
  themeResponsive.callbacks.push({ event: eventName, fn: callback });
};
const isMobile = () => themeResponsive.current_width < themeResponsive.min_width;
themeResponsive.mobile = isMobile();
function swapChildren(obj1, obj2) {
  const temp = obj2.children().detach();
  obj2.empty().append(obj1.children().detach());
  obj1.append(temp);
}
function toggleMobileStyles() {
  if (themeResponsive.mobile) {
    $("*[id^='_desktop_']").each((idx, el) => {
      const target = $(`#${el.id.replace("_desktop_", "_mobile_")}`);
      if (target.length) {
        swapChildren($(el), target);
      }
    });
    $("[data-collapse-hide-mobile]").collapse("hide");
  } else {
    $("*[id^='_mobile_']").each((idx, el) => {
      const target = $(`#${el.id.replace("_mobile_", "_desktop_")}`);
      if (target.length) {
        swapChildren($(el), target);
      }
    });
    $("[data-collapse-hide-mobile]").not(".show").collapse("show");
    $("[data-modal-hide-mobile].show").modal("hide");
  }
  emit("responsive update", {
    mobile: themeResponsive.mobile
  });
}
$(window).on("resize", () => {
  const cw = themeResponsive.current_width;
  const mw = themeResponsive.min_width;
  const w = window.innerWidth;
  const toggle = cw >= mw && w < mw || cw < mw && w >= mw;
  themeResponsive.current_width = w;
  themeResponsive.mobile = themeResponsive.current_width < themeResponsive.min_width;
  if (toggle) {
    toggleMobileStyles();
  }
});
$(() => {
  if (themeResponsive.mobile) {
    toggleMobileStyles();
  }
});
export { themeResponsive, emit, on };
